
import axios from "axios";
import instance,{BASE_URL} from "../../services/api";
import toast from 'react-hot-toast';


const ProjectViewController = ()=>{
//   const getErrorMessage = (error) => {
//   return (
//     error.response?.data?.detail ||   // Django REST Framework style
//     error.response?.data?.message ||  // custom backend message
//     error.response?.data?.error ||    // another fallback
//     error.message ||                  // Axios default
//     "Something went wrong!"
//   );
// };
    const getProjects = () => async (dispatch) => {
        dispatch({ type: "LOADING", payload: true });
        try {
          const response = await instance.get(`${BASE_URL}projects/`);
    
          const jsonString = JSON.stringify(response.data);
          const data = JSON.parse(jsonString);
          dispatch({ type: "GET_PROJECTS_SUCCESS", payload: data });
          dispatch({ type: "LOADING", payload: false });
        } catch (error) {
          dispatch({ type: "LOADING", payload: false });
          // const message = getErrorMessage(error);
          dispatch({
            type: "GET_PROJECTS_FAILURE",
            payload: { error: error },
          });
          // toast.error(message);
        }
      };

      const addProjects = (reqData) => async (dispatch) => {
        dispatch({ type: "LOADING", payload: true });
      
        const authToken = localStorage.getItem('access_token');
        const axiosInstance = axios.create({
          baseURL: `${BASE_URL}`,
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${authToken}`,
          },
        });
      
        try {
          const response = await axiosInstance.post('projects/', reqData);
          const data = response.data;
          dispatch({ type: "ADD_PROJECTS_SUCCESS", payload: data });
          dispatch(getProjects());
          toast.success("Project added sucessfully");
        } catch (error) {
          dispatch({
            type: "ADD_PROJECTS_FAILURE",
            payload: { error },
          });
          // const message = getErrorMessage(error);
        } finally {
          dispatch({ type: "LOADING", payload: false });
          // toast.error(message);
        }
      };
      
      
      const updateProject = (projectId, reqData) => async (dispatch) => {
        dispatch({ type: "LOADING", payload: true });
      
        const authToken = localStorage.getItem('access_token');
      
        const axiosInstance = axios.create({
          baseURL: `${BASE_URL}`,
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${authToken}`,
          },
        });
      
        try {
          const response = await axiosInstance.put(`projects/${projectId}/`, reqData);
      
          const data = response.data;
          dispatch({ type: "UPDATE_PROJECT_SUCCESS", payload: data });
          dispatch(getProjects());
          toast.success("Project updated sucessfully");
        } catch (error) {
          dispatch({
            type: "UPDATE_PROJECT_FAILURE",
            payload: { error },
          });
          // const message = getErrorMessage(error);
        } finally {
          dispatch({ type: "LOADING", payload: false });
          // toast.error(message);
        }
      };
      
      
        
    
      const deleteProject = (projectId) => async (dispatch) => {
        dispatch({ type: "LOADING", payload: true });
        try {
          const response = await instance.delete(
            `${BASE_URL}projects/${projectId}/`
          );
    
          const jsonString = JSON.stringify(response.data);
          const data = JSON.parse(jsonString);
          dispatch({ type: "DELETE_PROJECT_SUCCESS", payload: data });
          dispatch(getProjects());
          dispatch({ type: "LOADING", payload: false });
          toast.success("Project deleted sucessfully");
        } catch (error) {
          dispatch({ type: "LOADING", payload: false });
          // const message = getErrorMessage(error);
          dispatch({
            type: "DELETE_PROJECT_FAILURE",
            payload: { error: error },
          });
          // toast.error(message);
        }
      };

      
    
    
    return{
        getProjects, addProjects, updateProject, deleteProject
    }


};

export default ProjectViewController;